export const VISUAL_LABELS = {
  ishikawa: 'Espina de Ishikawa', five_whys: 'Cadena de 5 porqués', pareto: 'Pareto (barras + acumulado)',
  transformation_map: 'Mapa de transformaciones', weighted_matrix: 'Matriz ponderada', covey: 'Matriz de Covey',
  swot: 'FODA', pestel: 'PESTEL', porter: 'Porter 5 fuerzas', bcg: 'Matriz BCG', balanced_scorecard: 'Balanced Scorecard',
  pdca: 'Ciclo PDCA', decision_tree: 'Árbol de decisión', scenarios: 'Escenarios', generic: 'Genérico',
};

export const MODULE_LABELS = {
  revenue: 'Revenue', supply_chain: 'Supply Chain', operaciones: 'Operaciones', logistica: 'Logística', finanzas: 'Finanzas', rrhh: 'RRHH',
};
